module.exports = __webpack_public_path__ + "fonts/hinted-Atma-Medium.eba4c959.ttf";